import {
  Credential,
  CredentialEntity,
  MicrosoftCredentialToCredentialEntityMapper,
} from '@uploadcam/common';
import { RefreshCredentialAdapterInteractor } from '../../auth/domain/interactors/refresh-credential.interactor';

export class RefreshMicrosoftCredentialInteractor implements RefreshCredentialAdapterInteractor {
  constructor(private readonly clientId: string) {}

  public async execute(credential: Credential): Promise<CredentialEntity> {
    const mapper = new MicrosoftCredentialToCredentialEntityMapper(Date.now());
    const res = await fetch(`https://login.microsoftonline.com/common/oauth2/v2.0/token`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams({
        client_id: this.clientId,
        grant_type: 'refresh_token',
        refresh_token: credential.refreshToken,
      }),
    });

    return mapper.map(await res.json());
  }
}
